export default __webpack_public_path__ + "static/media/Asterisk.3e6810a2.svg";